import { ZoneType } from "@src/core/features/zones/entites";

export const options = {
  fillOpacity: 0.4,
  strokeOpacity: 1,
  strokeWeight: 1,
  clickable: true,
  draggable: false,
  editable: false,
  visible: true,   
  zIndex: 1,
};

export const colorByType = {
  [ZoneType.TEMPORARY]: '#FFC107',
  [ZoneType.PERMANENT]: '#BF3F32',
};
